import moment from "moment";
export function isMenuAvailable(storeDoc, menuTimeSetting) {
  let dateMoment = moment(new Date());
  if (storeDoc.TimezoneIanaFormat) dateMoment.tz(storeDoc.TimezoneIanaFormat);
  var todayDayOfWeekLabel = "";
  switch (dateMoment.day()) {
    case 0:
      todayDayOfWeekLabel = "Sunday";
      break;
    case 1:
      todayDayOfWeekLabel = "Monday";
      break;
    case 2:
      todayDayOfWeekLabel = "Tuesday";
      break;
    case 3:
      todayDayOfWeekLabel = "Wednesday";
      break;
    case 4:
      todayDayOfWeekLabel = "Thursday";
      break;
    case 5:
      todayDayOfWeekLabel = "Friday";
      break;
    case 6:
      todayDayOfWeekLabel = "Saturday";
      break;
  }
  if (
    menuTimeSetting.DayOfWeek.toLowerCase() != todayDayOfWeekLabel.toLowerCase()
  ) {
    return false;
  }
  let startTime = moment(
    dateMoment.format("DD MMMM YYYY") + " " + menuTimeSetting.StartTime,
    "DD MMMM YYYY h:mm a"
  );
  let endTime = moment(
    dateMoment.format("DD MMMM YYYY") + " " + menuTimeSetting.EndTime,
    "DD MMMM YYYY h:mm a"
  );
  if (dateMoment >= startTime && dateMoment <= endTime) {
    return true;
  } else {
    return false;
  }
}
export function operatingHours(storeDoc, date) {
  if (!date) date = new Date();
  else {
    date = new Date(date);
  }
  let todayDayOfWeek = date.getDay();
  var todayDayOfWeekLabel = "";
  switch (todayDayOfWeek) {
    case 0:
      todayDayOfWeekLabel = "Sunday";
      break;
    case 1:
      todayDayOfWeekLabel = "Monday";
      break;
    case 2:
      todayDayOfWeekLabel = "Tuesday";
      break;
    case 3:
      todayDayOfWeekLabel = "Wednesday";
      break;
    case 4:
      todayDayOfWeekLabel = "Thursday";
      break;
    case 5:
      todayDayOfWeekLabel = "Friday";
      break;
    case 6:
      todayDayOfWeekLabel = "Saturday";
      break;
  }

  let operatinHours = "";

  storeDoc.OperatingHours.forEach(item => {
    if (item.DayOfWeek.toLowerCase() == todayDayOfWeekLabel.toLowerCase()) {
      operatinHours = item;
    }
  });
  if (operatinHours) {
    let opening = moment(operatinHours.OpeningTime, "hh:mm");
    let closing = moment(operatinHours.ClosingTime, "hh:mm");
    return {
      openTime: opening.format("hh:mm A"),
      closeTime: closing.format("hh:mm A")
    };
  }
  return null;
}
export function initPickupDeliveryTimes(date, storeDoc) {
  date = moment(date);
  if (storeDoc.PreOrderPreparationTime > 0) {
    var nextOpenDate = getNexOpenDate(
      storeDoc,
      new moment().add(storeDoc.PreOrderPreparationTime, "h")
    );
    if (nextOpenDate.format("YYYY/MM/DD") != date.format("YYYY/MM/DD")) {
      date = moment(date.format("YYYY/MM/DD"));
    }
  }
  let operatingHour = operatingHours(storeDoc, date);
  let startingTime = operatingHour.openTime;
  let closingTime = operatingHour.closeTime;
  var closingDateTime = moment(
    moment(date).format("DD MMMM YYYY") + " " + closingTime,
    "DD MMMM YYYY h:mm a"
  );
  var startingDateTime = moment(
    moment(date).format("DD MMMM YYYY") + " " + startingTime,
    "DD MMMM YYYY h:mm a"
  );
  return populateTimes(startingDateTime, closingDateTime, storeDoc, date);
}
export function populateTimes(
  startingDateTime,
  closingDateTime,
  storeDoc,
  date
) {
  var times = new Array();
  if (startingDateTime < date) startingDateTime = date;
  var orderPrepartionTime = storeDoc.OrderPreparationTime || 0;
  startingDateTime.add(orderPrepartionTime, "m");
  do {
    times.push(startingDateTime.format("h:mm a"));
  } while (startingDateTime.add(20, "m") <= closingDateTime);
  return times;
}
export function availablePickupDeliveryDates(storeDoc, date) {
  var startDate = moment(date.format("YYYY/MM/DD"));
  if (storeDoc.PreOrderPreparationTime > 0) {
    startDate = moment(
      getNexOpenDate(
        storeDoc,
        moment(date).add(storeDoc.PreOrderPreparationTime, "h")
      ).format("YYYY/MM/DD")
    );
  }
  var disableAfter = moment(startDate).add(14, "d");
  return createDisableDates(startDate, disableAfter, storeDoc);
}
export function createDisableDates(startDate, twoWeekAfter, storeDoc) {
  return {
    customPredictor: function(date) {
      if (!IsStoreOpenOnDate(storeDoc, date)) {
        return true;
      }
      if (moment(date) < startDate) {
        return true;
      }
      if (moment(date) > twoWeekAfter) {
        return true;
      } else {
        return false;
      }
    }
  };
}

export function IsStoreOpenOnDate(storeDoc, date) {
  let day = new Date(date).getDay();
  var DayOfWeekLabel = "";
  switch (day) {
    case 0:
      DayOfWeekLabel = "Sunday";
      break;
    case 1:
      DayOfWeekLabel = "Monday";
      break;
    case 2:
      DayOfWeekLabel = "Tuesday";
      break;
    case 3:
      DayOfWeekLabel = "Wednesday";
      break;
    case 4:
      DayOfWeekLabel = "Thursday";
      break;
    case 5:
      DayOfWeekLabel = "Friday";
      break;
    case 6:
      DayOfWeekLabel = "Saturday";
      break;
  }
  let result = false;

  if (!storeDoc.IsInOperation) {
    return false;
  }

  storeDoc.OperatingHours.forEach(item => {
    if (item.DayOfWeek.toLowerCase() == DayOfWeekLabel.toLowerCase()) {
      result = true;
    }
  });
  return result;
}

export function IsStoreOpenAtTime(storeDoc, date) {
  let OpenOnDate = IsStoreOpenOnDate(storeDoc, date);

  if (OpenOnDate) {
    var openingHours = operatingHours(storeDoc, date);
    let dateMoment = moment(date);
    if (storeDoc.TimezoneIanaFormat) dateMoment.tz(storeDoc.TimezoneIanaFormat);
    let opening = moment(
      dateMoment.format("DD MMMM YYYY") + " " + openingHours.openTime,
      "DD MMMM YYYY h:mm a"
    );
    let closing = moment(
      dateMoment.format("DD MMMM YYYY") + " " + openingHours.closeTime,
      "DD MMMM YYYY h:mm a"
    );
    if (dateMoment >= opening && dateMoment <= closing) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

export function getNexOpenDate(storeDoc, startDate) {
  var index = -1;
  // eslint-disable-next-line no-constant-condition
  while (true) {
    index++;
    let today = startDate
      .add(index, "d")
      .toDate()
      .getDay();
    let operatinHours = storeDoc.OperatingHours[today];
    if (
      !operatinHours ||
      !operatinHours.OpeningTime ||
      !operatinHours.ClosingTime
    )
      continue;
    let now = startDate.add(index, "d").utc();
    let opening = moment(
      now.format("YYYY/MM/DD") + " " + operatinHours.OpeningTime,
      "YYYY/MM/DD hh:mm:ss"
    ).utc();
    let closing = moment(
      now.format("YYYY/MM/DD") + " " + operatinHours.ClosingTime,
      "YYYY/MM/DD hh:mm:ss"
    ).utc();
    if (index > 0) {
      return moment(
        now.format("YYYY/MM/DD") + " " + operatinHours.OpeningTime,
        "YYYY/MM/DD hh:mm:ss"
      ).utc();
    }
    if (now >= opening && now <= closing) {
      return now;
    }
  }
}
